import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Training from "./component/page/goattraining";
import Main from "./component/page/main/main";
import Products from "./component/page/products/GoatProducts";
import Cattleproduct from "./component/page/products/cattle";
import Poultryproduct from "./component/page/products/poultry";
import Dogproduct from "./component/page/products/dog";
import Addtocart from "./component/page/addtocart";
import DairyConsultantService from "./component/page/service/dairyConsultant";
import GoatFarmingService from "./component/page/service/goatFarming";
import VeterinaryService from "./component/page/service/veterinaryService";
import Consulting from "./component/page/service/consultingTeam";
import ContactUs from "./component/page/ContactUs/contactus";
import ErrorPage from "./component/page/Error/error";
import { ToastContainer } from "react-toastify";
import Blogs from "./component/page/Blogs/blogs";
import ProTraining from "./component/page/goattraining/proTraining";
import PrivacyPolicy from "./component/page/PrivacyPolicy/policy";
import { useLocation } from "react-router-dom";
import AllProducts from "./component/page/products/allProducts";
import FarmHouseEquipment from "./component/page/FarmHouseEquipment/equipment";
import ServiceFaq from "./component/page/service/faq";
import HumanConsumable from "./component/page/products/human";
import CropSeed from "./component/page/products/cropSeed";
import DownloadApp from "./component/page/DownloadApp";

const App = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/goatproduct" element={<Products />} />
        <Route path="/allproducts" element={<AllProducts />} />
        <Route path="/equipment" element={<FarmHouseEquipment />} />
        <Route path="/cattleproduct" element={<Cattleproduct />} />
        <Route path="/poultryproduct" element={<Poultryproduct />} />
        <Route path="/dogproduct" element={<Dogproduct />} />
        <Route path="/training" element={<Training />} />
        <Route path="/protraining" element={<ProTraining />} />
        <Route path="/productDetails/:id" element={<Addtocart />} />
        <Route path="/service" element={<VeterinaryService />} />
        <Route path="/consulting" element={<Consulting />} />
        <Route path="/dairyconsultant" element={<DairyConsultantService />} />
        <Route path="/goatfarming" element={<GoatFarmingService />} />
        <Route path="/faq" element={<ServiceFaq />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/blog" element={<Blogs />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/humanCunsumable" element={<HumanConsumable />} />
        <Route path="/cropseed" element={<CropSeed />} />
        <Route path="/download" element={<DownloadApp />} />
      </Routes>
    </>
  );
};

export default App;
